import { twMerge } from "tailwind-merge";
import { Bell } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { CountBadge } from "@shared/ui/CountBadge";

export type Props = {
  unreadCount: number;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

export function NotificationsNavButton({
  unreadCount,
  onClick,
  className,
}: Props) {
  return (
    <div className={twMerge("relative flex items-center", className)}>
      <Button
        variant="ghost"
        iconComponent={Bell}
        aria-label="Notifications"
        className="size-max"
        title="Open Notifications"
        onClick={onClick}
        data-testid="dashboard-nav-notifications"
      />
      <CountBadge count={unreadCount} />
    </div>
  );
}

export default NotificationsNavButton;
